import React from 'react';
import {
  Wrap,
  ImageWrap,
  Image,
  Content,
  Name,
  Price,
  Finance,
  Description,
  Actions,
  Action,
  Divider,
  TextPlaceholder,
} from './PlaceholderBikeCard.styled';

export const PlaceholderBikeCard = ({ className, isListingsPage }) => (
  <Wrap className={className}>
    <ImageWrap>
      <Image />
    </ImageWrap>
    <Content isListingsPage={isListingsPage}>
      <Name>
        <TextPlaceholder width={150} height={22} />
      </Name>
      <Price>
        <TextPlaceholder width={100} height={16} />
      </Price>
      <Description isListingsPage={isListingsPage}>
        <TextPlaceholder height={10} marginBottom={10} fluid />
        <TextPlaceholder height={10} marginBottom={10} fluid />
        <TextPlaceholder height={10} marginBottom={10} fluid />
        <TextPlaceholder height={10} fluid />
      </Description>
    </Content>
    <Actions>
      <Action>
        <TextPlaceholder width={80} height={15} />
      </Action>
      <Divider />
      <Action>
        <TextPlaceholder width={80} height={15} />
      </Action>
    </Actions>
  </Wrap>
);

export default PlaceholderBikeCard;
